<template>
  <transition name="fade-out" appear>
    <section class="menu-container">
      <transition-group
        appear
        mode="out-in"
        name="uploadbtn"
        tag="section"
        class="upl-btns"
        :style="{ '--label-color': globe.buttonBackgroundColor }"
      >
        <uploader-btn
          class="white-pill-m add-btn"
          key="pc"
          :style="{ '--index': '0.0s' }"
        >
          UPLOADEN
        </uploader-btn>
        <button
          @click="openPrintStore"
          v-if="printstore"
          class="white-pill-m add-btn"
          key="printstore"
          :style="{ '--index': '0.1s' }"
        >
          PRINTSTORE
        </button>
        <!--    <button
          @click="selectFromFileStore"
          v-if="filestore"
          class="white-pill-m add-btn"
          key="filestore"
          :style="{ '--index': '0.2s' }"
        >
          FILESTORE
        </button> -->
      </transition-group>
    </section>
  </transition>
</template>

<script>
import InteractionMixin from '@/mixins/InteractionMixin'
//import FileStoreSelectionDialog from '@/features/filestore/dialogs/FileStoreSelectionDialog'
export default {
  props: ['open', 'printstore', 'filestore'],
  mixins: [InteractionMixin],
  data() {
    return {
      show: false
    }
  },
  methods: {
    openPrintStore() {
      const printStore = this.rootStore.interactions.find(
        (ia) => ia.destination === 'printStore'
      )
      this.startInteraction(printStore)
    }
    /*   selectFromFileStore() {
      this.$emit('close')
      this.$modal.show(
        FileStoreSelectionDialog,
        {},
        { width: 650, height: 498, shiftY: 0.2 }
      )
    } */
  },
  computed: {
    globe() {
      return this.rootStore.globe
    }
  }
}
</script>

<style lang="scss" scoped>
.menu-container {
  height: 100%;
}
.upl-btns {
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
  padding-bottom: 30px;
  justify-content: center;
}

.add-btn {
  font-size: 11px;
  width: 115px;
  color: var(--label-color);
  margin: 7px 0;
  border-radius: 15px;
  border: none;
  line-height: 30px;
  padding: 0;

  transition: box-shadow 0.3s;

  &:hover {
    background: white;
    box-shadow: var(--default-shadow-hover);
  }
}

.uploadbtn-enter-active {
  animation: bounce-in 0.45s var(--index) both;
}

@keyframes bounce-in {
  0% {
    opacity: 0.2;
    transform: scale(0);
  }
  50% {
    transform: scale(1.05);
  }

  75% {
    transform: scale(0.9);
    opacity: 1;
  }
  100% {
    transform: scale(1);
  }
}
</style>
